import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { FacebookProvider, Page } from 'react-facebook'
import { CONFIG } from '../../config'

const StyledFacebookPosts = styled.div``

interface IFacebookPostsProps {
  className?: string
  facebookPageUrl: string
  onLoadSuccess: () => void
}

const FacebookPosts: React.FC<IFacebookPostsProps> = ({
  facebookPageUrl,
  className,
  onLoadSuccess,
}) => {
  const elRef = useRef()
  useEffect(() => {
    if (elRef) {
      setTimeout(() => {
        if (elRef?.current?.children?.[0]?.clientHeight > 0) {
          onLoadSuccess()
        }
      }, 2000)
    }
  }, [facebookPageUrl])
  return (
    <StyledFacebookPosts ref={elRef} className={className}>
      <FacebookProvider appId={CONFIG.FACEBOOK_APP_ID}>
        <Page
          href={facebookPageUrl}
          tabs="timeline"
          adaptContainerWidth
          smallHeader
        />
      </FacebookProvider>
    </StyledFacebookPosts>
  )
}

export { FacebookPosts }
